var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSuccesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.586,
    height: 47.05,
    viewBox: "0 0 83.586 47.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    transform: "translate(-17 -44.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M34.8,91.088H70.015a2.73,2.73,0,0,0,.58-.062,2.73,2.73,0,0,0,.58.062H91.3a2.709,2.709,0,0,0,0-5.418H88.977a2.709,2.709,0,0,1,0-5.418h7.352a2.709,2.709,0,1,0,0-5.418H87.816a2.709,2.709,0,1,0,0-5.418H63.05a2.709,2.709,0,1,0,0-5.418H40.992a2.709,2.709,0,1,0,0,5.418H25.513a2.709,2.709,0,0,0,0,5.418h9.674a2.709,2.709,0,1,1,0,5.418H19.709a2.709,2.709,0,0,0,0,5.418H34.8a2.709,2.709,0,1,0,0,5.418Zm63.077,0a2.709,2.709,0,1,0-2.709-2.709A2.709,2.709,0,0,0,97.877,91.088Z",
    transform: "translate(0 -11.648)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M172.5,45v2.322",
    transform: "translate(-95.326)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M172.5,59v2.322",
    transform: "translate(-95.326 -8.582)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M162.5,55h2.322",
    transform: "translate(-89.195 -6.13)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M176.5,55h2.322",
    transform: "translate(-97.778 -6.13)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M89.5,148v1.548",
    transform: "translate(-44.444 -63.142)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M89.5,160v1.548",
    transform: "translate(-44.444 -70.498)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M81.5,156h1.548",
    transform: "translate(-39.54 -68.046)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M93.5,156h1.548",
    transform: "translate(-46.897 -68.046)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M110.62,85.072a17.609,17.609,0,0,0,3.492-7.054,17.865,17.865,0,0,0-21.605-21.51A17.7,17.7,0,0,0,79.324,70.352a17.861,17.861,0,0,0,19.2,21.172,17.694,17.694,0,0,0,6.925-2.132",
    transform: "translate(-38.008 -6.743)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M110.62,85.072a17.609,17.609,0,0,0,3.492-7.054,17.865,17.865,0,0,0-21.605-21.51A17.7,17.7,0,0,0,79.324,70.352a17.861,17.861,0,0,0,19.2,21.172,17.694,17.694,0,0,0,6.925-2.132",
    transform: "translate(-38.008 -6.743)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M150.7,136.647a14.19,14.19,0,0,0,2.775-2.356Z",
    transform: "translate(-81.962 -54.738)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M150.7,136.647a14.19,14.19,0,0,0,2.775-2.356",
    transform: "translate(-81.962 -54.738)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M115.506,77.266q-.166,0-.333,0A18.53,18.53,0,0,1,96.728,60a16.347,16.347,0,1,0,18.777,17.266Z",
    transform: "translate(-40.46 -9.195)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M105.944,92.788a1.152,1.152,0,0,0-1.64.075,1.182,1.182,0,0,0,.074,1.658l5.464,5.045a1.613,1.613,0,0,0,2.3-.1l.05-.058,7.8-9.48a1.182,1.182,0,0,0-.151-1.653,1.152,1.152,0,0,0-1.635.152l-7.33,8.912Z",
    transform: "translate(-53.333 -26.36)",
    fill: "#fff",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M97.023,64.413a15.435,15.435,0,0,0-5.315,3.363,15.675,15.675,0,0,0-1.1,1.183m-1.064,1.423q-.41.62-.755,1.269-.255.479-.474.972",
    transform: "translate(-43.715 -11.901)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M96.426,64.1a.484.484,0,0,0-.34-.906Zm-2.374.579.239.42ZM90.941,67.01l-.336-.348Zm-1.475.871a.484.484,0,0,0,.74.623Zm-.291,2a.484.484,0,1,0-.807-.534Zm-1.158,1,.427.227h0Zm-.916.775a.484.484,0,1,0,.884.393Zm8.984-8.466a15.876,15.876,0,0,0-2.273,1.065l.478.841a14.917,14.917,0,0,1,2.135-1Zm-2.273,1.065a16.008,16.008,0,0,0-3.207,2.4l.672.7A15.046,15.046,0,0,1,94.291,65.1Zm-3.207,2.4a16.16,16.16,0,0,0-1.139,1.219l.74.623a15.187,15.187,0,0,1,1.071-1.146Zm-2.236,2.686q-.423.639-.779,1.309l.854.454q.334-.628.731-1.229Zm-.779,1.309q-.263.494-.488,1l.884.393q.212-.477.459-.941Z",
    transform: "translate(-42.949 -11.134)",
    fill: "#75a4fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSuccesIcon);
export default __webpack_public_path__ + "static/media/upload-succes-icon.5806b5a3b88b729fc2ac6f0fbfbe13f0.svg";
export { ForwardRef as ReactComponent };